/** The height of the app navigation. In CSS, use --tfd-appnav-height. */
export const AppNavHeight = 74;
/** How much should shift the logo up/down. */
export const AppNavShiftLogoBy = 12;
/** The max opacity for the shadow. */
export const AppNavMaxOpacity = 0.12;
